import type { IRequestConfig } from "angular";

export class AuthInterceptorFunctions {
    public static IsAuthenticationNeeded(options: IRequestConfig, apiUrl: string): boolean {
        return (
            new RegExp(apiUrl, "i").test(options.url) &&
            !/\/token/i.test(options.url) &&
            !(/:\/\/[^/]+\/translations/i.test(options.url) && options.method === "GET") &&
            !/\/profile\/twoFactorAuthentication/i.test(options.url) &&
            !/\/account\/twoFactorAuthMode/i.test(options.url) &&
            !/\/account\/verification/i.test(options.url) &&
            !/\/account\/verification\/:verificationKey/i.test(options.url) &&
            !/\/account\/resetPassword/i.test(options.url) &&
            !/\/account\/resetPassword\/confirm/i.test(options.url) &&
            !(options.url.substr(options.url.length - 5) === ".html")
        );
    }
}
